// Relative imports: Pages Functions esbuild does not resolve the `@/` alias
// (glossary → this module is pulled into /api/catalog).
import { editorPrimaryShort } from './editorPairs';
import { sampleById } from '../data/samples';

export type WorkspaceMode = 'view' | 'edit';

/** Canonical per-message workspace URL (View / Edit hub). */
export function messageWorkspaceHref(
  short: string,
  opts?: {
    mode?: WorkspaceMode;
    sample?: string;
    v?: string;
    help?: boolean;
    q?: string;
  },
): string {
  const mode = opts?.mode ?? 'view';
  const shortForRoute = mode === 'edit' ? editorPrimaryShort(short) : short;
  const params = new URLSearchParams();
  if (mode === 'edit') params.set('mode', 'edit');
  if (opts?.sample) params.set('sample', opts.sample);
  if (opts?.v) params.set('v', opts.v);
  if (opts?.help) params.set('help', '1');
  if (opts?.q) params.set('q', opts.q);
  const qs = params.toString();
  return `/messages/${shortForRoute}${qs ? `?${qs}` : ''}`;
}

/** Edit-mode workspace link (replaces legacy /try URLs). */
export function tryEditorHref(short: string): string {
  return messageWorkspaceHref(short, { mode: 'edit' });
}

/** Deep-link a sample into the message workspace (view mode). */
export function sampleWorkspaceHref(sampleId: string): string | null {
  const sample = sampleById(sampleId);
  if (!sample?.messageShort) return null;
  return messageWorkspaceHref(sample.messageShort, {
    mode: 'view',
    sample: sampleId,
  });
}
